import { useState } from 'react';
import { SpcOverrides, SpcOverridesMap } from '../../../shared/types/spc.ts';


export function useControlValueOverrides() {
    const [overrides, setOverrides] = useState<SpcOverridesMap>({});

    function handleSetOverrides(positionNumber: string, newOverrides: SpcOverrides | null) {
        if (newOverrides) {
            setOverrides(prev => ({
                ...prev,
                [positionNumber]: newOverrides,
            }));
        } else {
            setOverrides(prev => {
                const newMap = { ...prev };
                delete newMap[positionNumber];
                return newMap;
            });
        }
    }

    return {
        overrides,
        setOverrides: handleSetOverrides,
    }
}
